import { Site } from '@envato/foundation-types'
import * as React from 'react'
import { connect } from 'react-redux'

import { IRootState } from '../../common/reducers'

import { IItem } from '../../typings/searchResults'

interface IOwnProps {
  location: any // TODO: REMOVE THIS WHEN LOCATION IS NOT ADDING QUERY
  matches: IItem[]
  viewType?: string
  listName?: string
}

interface IStateProps {
  currentSite: Site
  viewType: string
}

const mapStateToProps = (
  state: IRootState,
  ownProps: IOwnProps
): IStateProps => {
  const {
    common: { currentSite },
    user: { preferences }
  } = state

  const nextViewType = ownProps.viewType || preferences.searchResultsViewType

  return {
    currentSite,
    viewType: nextViewType
  }
}

export type Props = IOwnProps & IStateProps

const createSearchResultBodyContainer = (
  component: React.ComponentType<Props>
) =>
  connect<IStateProps, void, IOwnProps, IRootState>(mapStateToProps)(component)

export default createSearchResultBodyContainer
